import { motion } from "framer-motion";
import LottiePlayer from "lottie-react";
import { useState } from "react";
import { FaArrowLeft } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { useRecoilValue, useSetRecoilState } from "recoil";
import loadingAnimation from "../animations/loader.json";
import { currentUser, logIn } from "../atoms/auth";
import { auth } from "../functions/firebase";

export default function VerifyNumber() {

    const [code, setCode] = useState("")
    const setUser = useSetRecoilState(currentUser)
    const {confirmationResult} = useRecoilValue(logIn)
    const navigate = useNavigate()
    const [loading, setLoading] = useState(false)

    function verifyCode(e) {

        if(e?.preventDefault) {
            e.preventDefault()
        }

        setLoading(true)
        confirmationResult.confirm(code).then((result) => {
            // User signed in successfully.
            const user = result.user;
            setUser(user)
            setLoading(false)
            navigate("/auth-1/" + auth.currentUser.uid)
            // ...
          }).catch((error) => {
            // User couldn't sign in (bad verification code?)
            setLoading(false)
            window.alert(error.message.replace("firebase").replace("Firebase"))
            // ...
          });
      
    }

    function focus() {
        document.getElementById("code").focus()
    }
 
    return (
        <>
            <motion.div
            initial={{ y: 20, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}>
                <div id="authForm">
                    <form onSubmit={verifyCode}>
                        <div className="row" style={{ width: "100%", marginBottom: 40 }}>
                            <FaArrowLeft 
                                color="grey"
                                className="back-button"
                                onClick={() => window.history.back()}
                            />
                            <div>
                                <p>Verify Number</p>
                            </div>
                        </div>
                        {/* <h1>Register</h1> */}
                        <p style={{ marginBottom: 20 }}>A 6 digit verification code was sent to your number, enter it then continue</p>
                        <div className="row spaceBetween"
                            style={{ marginBottom: 20 }}
                        >
                            <div className="code-box" onClick={focus}>
                                {code[0] || "-"}
                            </div>
                            <div className="code-box" onClick={focus}>
                                {code[1] || "-"}
                            </div>
                            <div className="code-box" onClick={focus}>
                                {code[2] || "-"}
                            </div>
                            <div className="code-box" onClick={focus}>
                                {code[3] || "-"}
                            </div>
                            <div className="code-box" onClick={focus}>
                                {code[4] || "-"}
                            </div>
                            <div className="code-box" onClick={focus}>
                                {code[5] || "-"}
                            </div>
                        </div>
                        <button type="submit" id="sign-in-button">Continue</button>
                        <input 
                            placeholder="Verification Code"
                            type="number"
                            value={code}
                            onChange={e => {
                                const newVal = e.target.value
                                setCode(newVal.substring(0, 6))
                            }}
                            id="code"
                            autoComplete="off"
                            autoCorrect="off"
                            style={{ opacity: 0 }}
                        />
                    </form>
                </div>
                <div className="log-footer">
                    <p>A Kulture Product</p>
                </div>
            </motion.div>
            {loading && (
                <div style={{
                    position: 'absolute',
                    top: 0,
                    width: '100vw',
                    height: "100vh",
                    backgroundColor: '#171717',
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center"
                }}>
                    <LottiePlayer 
                        animationData={loadingAnimation}
                        loop={true}
                        style={{
                            width: 200,
                        }}
                    />
                </div>
            )}
        </>
    )
}